import FloatingCartContainer from './FloatingCartContainer.jsx';

export default FloatingCartContainer;


// WEBPACK FOOTER //
// ./src/components/FloatingCart/index.jsx